module.exports = __webpack_public_path__ + "static/media/chevron-up-blue.f2fc6a0a.svg";